import changeCurrentLocation from 'actions/lib/change_current_location';
import LoadUserAdmin from 'actions/users/load_user_admin';
import TeamEditor from 'models/location/team_editor';
import UsersAdmin from 'models/location/users_admin';

export default class OpenTeam {
  constructor(context) {
    this.context = context;
  }

  run(teamId) {
    if (!this.context.stores.appFeatures.get().isEnabled('teamManagement')) {
      this.context.router.navigateHome();
      return;
    }

    if (!(this.context.stores.currentLocation.get() instanceof UsersAdmin)) {
      this.context.executeAction(LoadUserAdmin);
    }
    changeCurrentLocation(this.context, TeamEditor.create({ teamId }));
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/teams/open_team.js